/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IngestScaleSloReportDto,
  IngestScaleSnapshotDto,
} from '../models/index';
import {
    IngestScaleSloReportDtoFromJSON,
    IngestScaleSloReportDtoToJSON,
    IngestScaleSnapshotDtoFromJSON,
    IngestScaleSnapshotDtoToJSON,
} from '../models/index';

export interface SloReportRequest {
    milestone?: string;
    tenantId?: string;
    executionId?: string;
    admissionSoakAttempts?: number;
    m2MaxJobDurationSeconds?: number;
    workflowSoakAttempts?: number;
    backlogDrainRows?: number;
    instanceId?: string;
}

export interface SnapshotRequest {
    tenantId?: string;
    executionId?: string;
}

/**
 * IntegrationsIngestScaleApi - interface
 * 
 * @export
 * @interface IntegrationsIngestScaleApiInterface
 */
export interface IntegrationsIngestScaleApiInterface {
    /**
     * 
     * @summary Ingest operability dashboard: lag, MDM job age, pool wait, case list p95
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsIngestScaleApiInterface
     */
    dashboardRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Ingest operability dashboard: lag, MDM job age, pool wait, case list p95
     */
    dashboard(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Milestone SLO report for soak tests and dashboards
     * @param {string} [milestone] 
     * @param {string} [tenantId] 
     * @param {string} [executionId] 
     * @param {number} [admissionSoakAttempts] 
     * @param {number} [m2MaxJobDurationSeconds] 
     * @param {number} [workflowSoakAttempts] 
     * @param {number} [backlogDrainRows] 
     * @param {string} [instanceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsIngestScaleApiInterface
     */
    sloReportRaw(requestParameters: SloReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IngestScaleSloReportDto>>;

    /**
     * Milestone SLO report for soak tests and dashboards
     */
    sloReport(requestParameters: SloReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IngestScaleSloReportDto>;

    /**
     * 
     * @summary Ingest shard pressure snapshot for soak/SLO reporting
     * @param {string} [tenantId] 
     * @param {string} [executionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsIngestScaleApiInterface
     */
    snapshotRaw(requestParameters: SnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IngestScaleSnapshotDto>>;

    /**
     * Ingest shard pressure snapshot for soak/SLO reporting
     */
    snapshot(requestParameters: SnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IngestScaleSnapshotDto>;

}

/**
 * 
 */
export class IntegrationsIngestScaleApi extends runtime.BaseAPI implements IntegrationsIngestScaleApiInterface {

    /**
     * Ingest operability dashboard: lag, MDM job age, pool wait, case list p95
     */
    async dashboardRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/ingest-scale/dashboard`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Ingest operability dashboard: lag, MDM job age, pool wait, case list p95
     */
    async dashboard(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.dashboardRaw(initOverrides);
        return await response.value();
    }

    /**
     * Milestone SLO report for soak tests and dashboards
     */
    async sloReportRaw(requestParameters: SloReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IngestScaleSloReportDto>> {
        const queryParameters: any = {};

        if (requestParameters['milestone'] != null) {
            queryParameters['milestone'] = requestParameters['milestone'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['executionId'] != null) {
            queryParameters['executionId'] = requestParameters['executionId'];
        }

        if (requestParameters['admissionSoakAttempts'] != null) {
            queryParameters['admissionSoakAttempts'] = requestParameters['admissionSoakAttempts'];
        }

        if (requestParameters['m2MaxJobDurationSeconds'] != null) {
            queryParameters['m2MaxJobDurationSeconds'] = requestParameters['m2MaxJobDurationSeconds'];
        }

        if (requestParameters['workflowSoakAttempts'] != null) {
            queryParameters['workflowSoakAttempts'] = requestParameters['workflowSoakAttempts'];
        }

        if (requestParameters['backlogDrainRows'] != null) {
            queryParameters['backlogDrainRows'] = requestParameters['backlogDrainRows'];
        }

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/ingest-scale/slo-report`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IngestScaleSloReportDtoFromJSON(jsonValue));
    }

    /**
     * Milestone SLO report for soak tests and dashboards
     */
    async sloReport(requestParameters: SloReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IngestScaleSloReportDto> {
        const response = await this.sloReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ingest shard pressure snapshot for soak/SLO reporting
     */
    async snapshotRaw(requestParameters: SnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IngestScaleSnapshotDto>> {
        const queryParameters: any = {};

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['executionId'] != null) {
            queryParameters['executionId'] = requestParameters['executionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/ingest-scale/snapshot`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IngestScaleSnapshotDtoFromJSON(jsonValue));
    }

    /**
     * Ingest shard pressure snapshot for soak/SLO reporting
     */
    async snapshot(requestParameters: SnapshotRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IngestScaleSnapshotDto> {
        const response = await this.snapshotRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
